





















































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { FacilityModule } from '@/store/modules/facility.module'
import { EUserPermissions, IFacilityPayerGroup, IPayerType } from '@zunta/configurations'
import Api from '@/api'
import { User } from '@/classes/User'
import Switcher from '@/components/Switcher.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import TableSubRow from '@/components/tables/TableSubRow.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import PayerGroupModal from '@/views/app/management/settings/pages/facility/payers/components/PayerGroupModal.vue'
import Editable from '@/components/inputsV2/Editable.vue'
import { getSelectContentLabel } from '@/utils/helpers'
import Icon from '@/components/Icon.vue'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'

@Component({
  components: {
    Icon,
    Editable,
    PayerGroupModal,
    SelectV2,
    TableSubRow,
    Table,
    Card,
    Checkbox,
    Switcher,
    StatusFacilityComplete
  }
})
export default class FacilitySettingsPayerTypes extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User
  getSelectContentLabel: Function = getSelectContentLabel

  openedRowIndex: number = -1
  payerType: any = null
  showGroupModal: boolean = false
  payerTypesLocal: IPayerType[] = []
  payerTypesLocalTotal: number = 0
  preventChange: boolean = false

  config: ITableConfig = {
    usePagination: true,
    useQuery: true,
    useSubrow: true,
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1rem; right: -1.5rem;',
      class: 'rounded-bottom'
    },
    fetchFunction: this.fetchData,
    // rowClick: this.openSubrow,
    maxHeight: 'calc(100vh - 365px)',
    minHeight: 'calc(100vh - 365px)',
    columns: [
      {
        minWidth: '150px',
        width: 40,
        key: 'payer_name',
        searchKey: 'payerNameAndGroup',
        hasSort: true,
        hasSearch: true,
        label: 'Payer Name',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 35,
        key: 'facilityPayerGroup',
        searchKey: 'facilityPayerGroup',
        hasSort: true,
        hasSearch: true,
        label: 'Group',
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 20,
        key: 'active',
        searchKey: 'active',
        hasSort: true,
        hasSearch: true,
        label: 'Enabled',
        type: ETableColumnType.select,
        options: [
          {
            key: 'enabled',
            content: 'Enabled',
            value: 'true'
          },
          {
            key: 'disabled',
            content: 'Disabled',
            value: 'false'
          }
        ]
      },
      // {
      //   minWidth: '150px',
      //   width: 17,
      //   key: 'hasPrivate',
      //   searchKey: 'hasPrivate',
      //   hasSort: false,
      //   hasSearch: false,
      //   label: 'Private',
      //   type: ETableColumnType.select,
      //   options: [
      //     {
      //       key: 'enabled',
      //       content: 'Enabled',
      //       value: true
      //     },
      //     {
      //       key: 'disabled',
      //       content: 'Disabled',
      //       value: false
      //     }
      //   ]
      // },
      {
        minWidth: '50px',
        key: 'actions',
        width: 5,
        type: ETableColumnType.actions
      }
    ]
  }

  get payerGroup () {
    return this.$store.state.facility.facilityPayerGroups || []
  }

  get payerGroupOptions () {
    return this.payerGroup.map((item: IFacilityPayerGroup) => ({
      key: item.id,
      value: item.id,
      content: item.payerGroupName
    }))
  }

  get monthDaysListItems () {
    const list = []
    for (let i = 1; i < 32; i++) {
      const label = i < 29 ? i : `${i} or last month day`
      list.push({
        key: i,
        value: i,
        content: label
      })
    }
    return list
  }

  get selectedFacility () {
    return this.$store.state.facility.selectedFacility
  }

  get willowPayers () {
    return this.$store.state.facility.willowPayers
  }

  get facilitiesActivePayerTypesMap (): { [k: string]: IPayerType[] } {
    return this.$store.state.facility.facilitiesActivePayerTypesMap
  }

  get activePayersForFacility (): IPayerType[] {
    return (this.facilitiesActivePayerTypesMap &&
      this.facilitiesActivePayerTypesMap[this.selectedFacility.id]) || []
  }

  get willowPayersSelect () {
    return this.willowPayers.map((item: any) => {
      return {
        key: item.id,
        value: item.id,
        content: item.name
      }
    })
  }

  async mounted () {
    this.$watch('payerTypesLocal', async () => {
      this.setActiveFacilityPayersMap()
      await this.updatePayerTypes()
    }, { deep: true })
    this.$watch(() => (this.activePayersForFacility), () => {
      this.facilityModuleInstance.SET_FACILITY_COMPLETE_LEVEL([
        { type: 'payers', value: this.activePayersForFacility.length ? 100 : 0 }
      ])
    })
  }

  async tableFetch () {
    const table: any = this.$refs.table

    if (!table) {
      return
    }
    // @ts-ignore
    await table.initSearch()
  }

  async fetchData (filters: any) {
    const {
      payerTypes,
      total
    } = await this.facilityModuleInstance.getAllFacilitiesPayerTypes({ facilityIds: [this.selectedFacility.id], ...filters })
    this.preventChange = true
    this.payerTypesLocal = payerTypes.map((item: IPayerType) => {
      return {
        ...item,
        // @ts-ignore
        facilityPayerGroup: item.facilityPayerGroup && item.facilityPayerGroup.id ? item.facilityPayerGroup.id : null
      }
    })
    this.payerTypesLocalTotal = total
    await Promise.all([
      this.facilityModuleInstance.getFacilityPayerGroups(this.selectedFacility.id),
      this.facilityModuleInstance.getWillowPayers({})
    ])
    this.closeSubrow()
    this.$nextTick(() => {
      this.preventChange = false
    })
  }

  openSubrow (item: any, index: number) {
    if (!item.active) {
      return
    }

    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      this.payerType = null
      return
    }

    this.payerType = item
    this.openedRowIndex = index
  }

  closeSubrow () {
    this.openedRowIndex = -1
    this.payerType = null
  }

  setActiveFacilityPayersMap () {
    const newActivePayers = [
      ...this.payerTypesLocal,
      ...this.activePayersForFacility.filter(
        payer => !this.payerTypesLocal.map(payerLocal => payerLocal.id).includes(payer.id)
      )
    ].filter(payer => payer.active)
    this.facilityModuleInstance.SET_FACILITIES_ACTIVE_PAYER_TYPE_MAP({
      ...this.facilitiesActivePayerTypesMap,
      [this.selectedFacility.id]: newActivePayers
    })
  }

  async updatePayerTypes () {
    if (!this.selectedFacility || this.preventChange) {
      return
    }

    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_PAYER_TYPES)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify Payers`,
        icon: 'warning'
      })
      return
    }
    const table: any = this.$refs.table

    if (!table) {
      return
    }

    try {
      table.isLoading = true
      await this.facilityModuleInstance.updatePayerTypes({
        facilityId: this.selectedFacility.id,
        payerTypes: this.payerTypesLocal.map((pt: IPayerType) => ({
          ...pt,
          facilityPayerGroup: pt.facilityPayerGroup ? pt.facilityPayerGroup : null
        }))
      })
    } finally {
      table.isLoading = false
    }
  }
}
